import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static identifier = "banner-duration"
  static targets = ["select", "customFields"]

  connect() {
    this.toggleCustom()
  }

  toggleCustom() {
    const isCustom = this.selectTarget.value === "custom"
    
    if (isCustom) {
      this.customFieldsTarget.style.display = "block"
    } else {
      this.customFieldsTarget.style.display = "none"
    }
  }
}
